webpackJsonp([0],{

/***/ "/dr+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Workspace_vue__ = __webpack_require__("lWwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be69502_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Workspace_vue__ = __webpack_require__("b92S");
function injectStyle (ssrContext) {
  __webpack_require__("nBUJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4be69502"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Workspace_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be69502_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Workspace_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "11lO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"header"},[_c('h1',{staticClass:"logo is-medium"},[_vm._v("UNY")]),_vm._v(" "),_c('nav',{staticClass:"header-menu"},[_c('div',{staticClass:"pulldown"},[_c('a',{attrs:{"href":"javascript:void(0);"}},[_vm._v("Language "),_c('i',{staticClass:"fa fa-angle-down"})]),_vm._v(" "),_c('div',{staticClass:"pulldown-content"},[_c('a',{staticClass:"button is-list",attrs:{"href":"./"}},[_vm._v("English")]),_vm._v(" "),_c('a',{staticClass:"button is-list",attrs:{"href":"./index_ja.html"}},[_vm._v("日本語")])])]),_vm._v(" "),_c('div',{staticClass:"pulldown"},[_c('a',{attrs:{"href":"javascript:void(0);"}},[_vm._v("Document")]),_vm._v(" "),_c('div',{staticClass:"pulldown-content"},[_c('p',[_vm._v("Coming soon ;)")])])]),_vm._v(" "),_c('div',{staticClass:"pulldown"},[_c('a',{attrs:{"href":"javascript:void(0);"}},[_vm._v("Theme")]),_vm._v(" "),_c('div',{staticClass:"pulldown-content"},[_c('p',[_vm._v("Coming soon ;)")])])]),_vm._v(" "),_c('a',{staticClass:"button is-white is-small",attrs:{"href":"https://github.com/unys/uny"}},[_c('i',{staticClass:"fa fa-github"}),_vm._v(" GitHub")]),_vm._v(" "),_c('a',{staticClass:"button is-small",attrs:{"href":"https://github.com/unys/uny/archive/master.zip"}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" Download")])]),_vm._v(" "),_c('button',{staticClass:"button is-burger hide-on-medium hide-on-large offcanvas-open"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])]),_vm._v(" "),_c('div',{staticClass:"hero is-center is-gradation"},[_c('div',{staticClass:"uny-logo"}),_vm._v(" "),_c('div',{staticClass:"type-h1"},[_vm._v("It's modern CSS framework. "),_c('small',[_vm._v("Beta")])]),_vm._v(" "),_c('p',[_vm._v("UNY is a simple CSS framework. In addition to the basic components such as cards and buttons, "),_c('br'),_vm._v("it is also possible to extend theme files.")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"button is-white is-medium",attrs:{"href":"./demos/"}},[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" Demos")])])]),_vm._v(" "),_c('main',{staticClass:"main"},[_c('div',{staticClass:"content"},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"inner is-small"},[_c('h2',[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Feature")]),_vm._v(" "),_c('h3',[_vm._v("Various components")]),_vm._v(" "),_c('p',[_vm._v("I will show you some of the components that can be expressed in UNY. "),_c('br'),_vm._v("Various things such as buttons and form parts that can be used by itself, things such as lists and cards that can be used as a set.")]),_vm._v(" "),_c('h4',[_vm._v("Button")]),_vm._v(" "),_c('div',{staticClass:"grid is-col-center is-row-middle"},[_c('div',[_c('a',{staticClass:"button",attrs:{"href":"#"}},[_vm._v("Button")])]),_vm._v(" "),_c('div',[_c('a',{staticClass:"button is-white",attrs:{"href":"#"}},[_vm._v("Button")])]),_vm._v(" "),_c('div',[_c('a',{staticClass:"button is-small",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Home")])]),_vm._v(" "),_c('div',[_c('a',{staticClass:"button is-white is-large",attrs:{"href":"#"}},[_vm._v("Button")])]),_vm._v(" "),_c('div',[_c('a',{staticClass:"button is-icon",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Home")])]),_vm._v(" "),_c('div',[_c('a',{staticClass:"button is-round",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-plus"})])])]),_vm._v(" "),_c('h4',[_vm._v("Form parts")]),_vm._v(" "),_c('div',{staticClass:"grid is-col-center is-row-middle"},[_c('div',[_c('input',{staticClass:"input",attrs:{"type":"text","placeholder":"text"}})]),_vm._v(" "),_c('div',[_c('div',{staticClass:"field"},[_c('input',{staticClass:"input",attrs:{"type":"text","placeholder":"Search"}}),_vm._v(" "),_c('button',{staticClass:"button"},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',[_c('label',{staticClass:"input is-checkbox",attrs:{"for":"checkbox-1"}},[_c('input',{attrs:{"type":"checkbox","name":"","id":"checkbox-1"}}),_vm._v(" "),_c('span',[_vm._v("Checkbox")])])]),_vm._v(" "),_c('div',[_c('label',{staticClass:"input is-radio",attrs:{"for":"radio-1"}},[_c('input',{attrs:{"type":"radio","name":"radio","id":"radio-1"}}),_vm._v(" "),_c('span',[_vm._v("Radio")])])])]),_vm._v(" "),_c('h4',[_vm._v("Tree type list, Card")]),_vm._v(" "),_c('div',{staticClass:"grid is-col-medium-2 is-center is-middle"},[_c('div',[_c('div',{staticClass:"tree"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Introduction")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Download")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Usgae")])]),_vm._v(" "),_c('li',{staticClass:"is-parent is-current"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Components")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Header")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Footer")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Layout")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu")])])])])])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-image",staticStyle:{"background-image":"url(https://source.unsplash.com/random)"}}),_vm._v(" "),_c('h3',[_vm._v("Heading")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Molestiae, debitis.")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"button",attrs:{"href":"#"}},[_vm._v("Download")])])])])])])]),_vm._v(" "),_c('section',{staticClass:"section is-center is-gradation"},[_c('div',{staticClass:"inner"},[_c('h2',[_vm._v("Learn more")]),_vm._v(" "),_c('p',[_vm._v("If you want to check all the components included in version 0.1 (beta version), "),_c('br'),_vm._v("please see the following page.")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"button is-ghost-white is-medium",attrs:{"href":"./demos/"}},[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" Demos")])])])]),_vm._v(" "),_c('section',{staticClass:"section"},[_c('div',{staticClass:"inner is-small"},[_c('h2',[_c('i',{staticClass:"fa fa-bolt"}),_vm._v(" Quick start")]),_vm._v(" "),_c('h3',[_vm._v("Using CDN")]),_vm._v(" "),_c('p',[_vm._v("In addition to downloading and loading CSS and JS files, "),_c('br'),_vm._v("you can easily start by using CDN.")]),_vm._v(" "),_c('p',[_vm._v("Add the following description in the "),_c('code',[_vm._v("<head>")]),_vm._v(" tag of the web page you want to use UNY.")]),_vm._v(" "),_c('pre',[_c('code',{staticClass:"html"},[_vm._v("<link rel=\"stylesheet\" href=\"https://unpkg.com/uny@latest/dist/css/uny.min.css\">\n<script src=\"https://unpkg.com/uny@latest/dist/js/uny.min.js\"></script>")])]),_vm._v(" "),_c('p',[_vm._v("Write the HTML tag of the component you want to use.")]),_vm._v(" "),_c('pre',[_c('code',{staticClass:"html"},[_vm._v("<div class=\"card\">\n  <div class=\"card-image\" style=\"background-image: url(https://source.unsplash.com/random);\"></div>\n  <h3>Heading</h3>\n  <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Molestiae, debitis.</p>\n  <p><a href=\"#\" class=\"button\">Download</a></p>\n</div>")])]),_vm._v(" "),_c('p',[_vm._v("This alone displays the card type component with the image embedded 🎉")])])]),_vm._v(" "),_c('section',{staticClass:"section"},[_c('div',{staticClass:"inner is-small"},[_c('h2',[_c('i',{staticClass:"fa fa-book"}),_vm._v(" Document")]),_vm._v(" "),_c('p',[_vm._v("Usage, introduction of other functions, component introduction etc. "),_c('br'),_vm._v("are described in detail in the document. "),_c('br'),_vm._v("Two kinds of documents are prepared, English and Japanese.")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"button is-disabled",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-book"}),_vm._v(" Coming soon ;)")])])])]),_vm._v(" "),_c('section',{staticClass:"section"},[_c('div',{staticClass:"inner is-small"},[_c('h2',[_c('i',{staticClass:"fa fa-github"}),_vm._v(" View on GitHub")]),_vm._v(" "),_c('p',[_vm._v("UNY was developed by "),_c('a',{attrs:{"href":"https://twitter.com/kokushing"}},[_vm._v("@kokushing")]),_vm._v(" and is open source (MIT license) on GitHub."),_c('br'),_vm._v("Please send us feedback, requests, bug reports and pull requests!")]),_vm._v(" "),_c('p',[_vm._v("If you like it, please press Star ;)")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"button",attrs:{"href":"https://github.com/unys/uny"}},[_c('i',{staticClass:"fa fa-github"}),_vm._v(" GitHub page")])])])])])]),_vm._v(" "),_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"inner"},[_c('div',{staticClass:"logo is-medium"},[_vm._v("UNY "),_c('small',[_vm._v("Beta")])]),_vm._v(" "),_c('div',{staticClass:"margin-left-small margin-right-small"},[_c('p',[_vm._v("A modern CSS framework. "),_c('br'),_vm._v("UNY is provided with "),_c('a',{attrs:{"href":"https://github.com/unys/uny/blob/master/LICENSE"}},[_vm._v("MIT license.")]),_vm._v(" Made by @kokushin ♥ OSS")]),_vm._v(" "),_c('p',[_vm._v("Icon fonts by Font Awesome, Photo by Unsplash")])]),_vm._v(" "),_c('small',{staticClass:"copyright"},[_vm._v("© 2017 UNY")])])]),_vm._v(" "),_c('div',{staticClass:"offcanvas"},[_c('div',{staticClass:"offcanvas-overlay offcanvas-close"}),_vm._v(" "),_c('div',{staticClass:"offcanvas-content"},[_c('button',{staticClass:"button is-close offcanvas-close"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),_c('div',{staticClass:"inner"},[_c('div',{staticClass:"offcanvas-menu"},[_c('a',{staticClass:"is-current",attrs:{"href":"./"}},[_vm._v("English")]),_vm._v(" "),_c('a',{attrs:{"href":"./index_ja.html"}},[_vm._v("日本語")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('a',{staticClass:"button is-white is-small",attrs:{"href":"https://github.com/unys/uny"}},[_c('i',{staticClass:"fa fa-github"}),_vm._v(" GitHub")]),_vm._v(" "),_c('a',{staticClass:"button is-small",attrs:{"href":"https://github.com/unys/uny/archive/master.zip"}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" Download")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("version 0.1-beta")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6aNs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "80Q4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GPJG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_vm._v(" "),_c('Workspace'),_vm._v(" "),_c('Preview')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header is-gradation"},[_c('h1',{staticClass:"logo is-small is-center"},[_vm._v("UNY Theme Generator ✨")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KvDf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preview_vue__ = __webpack_require__("fV88");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8fa6816_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preview_vue__ = __webpack_require__("11lO");
function injectStyle (ssrContext) {
  __webpack_require__("80Q4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d8fa6816"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preview_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8fa6816_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff805aaa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("GPJG");
function injectStyle (ssrContext) {
  __webpack_require__("OzyJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff805aaa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uny__ = __webpack_require__("6aNs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uny___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uny__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "OzyJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b92S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"inner is-small"},[_c('div',{staticClass:"controls"},[_c('div',[_c('label',{staticClass:"label",attrs:{"for":"colorSet"}},[_vm._v("Color set")]),_vm._v(" "),_c('label',{staticClass:"input is-select is-col-full",attrs:{"for":"colorSet"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.colorSet),expression:"colorSet"}],attrs:{"id":"colorSet"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.colorSet=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeColorSet]}},[_c('option',{attrs:{"value":"custom"}},[_vm._v("Custom")]),_vm._v(" "),_c('option',{attrs:{"value":"dark"}},[_vm._v("Dark theme")]),_vm._v(" "),_c('option',{attrs:{"value":"mint"}},[_vm._v("Mint theme")])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"grid is-col-2"},[_c('div',[_c('label',{staticClass:"label",attrs:{"for":"baseColor"}},[_vm._v("Base color")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.baseColor),expression:"baseColor"}],staticClass:"input is-col-full",attrs:{"type":"text","placeholder":"#000000","id":"baseColor"},domProps:{"value":(_vm.baseColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.baseColor=$event.target.value}}})]),_vm._v(" "),_c('div',[_c('label',{staticClass:"label",attrs:{"for":"accentColor"}},[_vm._v("Accent color")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.accentColor),expression:"accentColor"}],staticClass:"input is-col-full",attrs:{"type":"text","placeholder":"#000000","id":"accentColor"},domProps:{"value":(_vm.accentColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.accentColor=$event.target.value}}})]),_vm._v(" "),_c('div',[_c('label',{staticClass:"label",attrs:{"for":"secondaryColor"}},[_vm._v("Secondary color")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.secondaryColor),expression:"secondaryColor"}],staticClass:"input is-col-full",attrs:{"type":"text","placeholder":"#000000","id":"secondaryColor"},domProps:{"value":(_vm.secondaryColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.secondaryColor=$event.target.value}}})]),_vm._v(" "),_c('div',[_c('label',{staticClass:"label",attrs:{"for":"textColor"}},[_vm._v("Text color")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.textColor),expression:"textColor"}],staticClass:"input is-col-full",attrs:{"type":"text","placeholder":"#000000","id":"textColor"},domProps:{"value":(_vm.textColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.textColor=$event.target.value}}})]),_vm._v(" "),_c('div',[_c('label',{staticClass:"label",attrs:{"for":"linkColor"}},[_vm._v("Link color")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.linkColor),expression:"linkColor"}],staticClass:"input is-col-full",attrs:{"type":"text","placeholder":"#000000","id":"linkColor"},domProps:{"value":(_vm.linkColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.linkColor=$event.target.value}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"unit"},[_c('button',{staticClass:"button is-white",on:{"click":_vm.previewTheme}},[_c('i',{staticClass:"fa fa-eye"}),_vm._v(" Preview")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":_vm.createFile}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" Download")])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fV88":
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "lWwB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hex_rgb__ = __webpack_require__("GhJf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hex_rgb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hex_rgb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      colorSet: 'custom',
      baseColor: '',
      accentColor: '',
      secondaryColor: '',
      textColor: '',
      linkColor: ''
    };
  },

  methods: {
    changeColorSet: function changeColorSet() {
      switch (this.colorSet) {
        case 'custom':
          this.baseColor = '';
          this.accentColor = '';
          this.secondaryColor = '';
          this.textColor = '';
          this.linkColor = '';
          break;
        case 'dark':
          this.baseColor = '#263238';
          this.accentColor = '#607d8b';
          this.secondaryColor = '#37474f';
          this.textColor = '#f2f2f2';
          this.linkColor = '#1976d2';
          break;
        case 'mint':
          this.baseColor = '#009688';
          this.accentColor = '#00897b';
          this.secondaryColor = '#00695c';
          this.textColor = '#f2f2f2';
          this.linkColor = '#00e5ff';
          break;
      }
    },
    previewTheme: function previewTheme() {
      if (this.baseColor !== '' && this.accentColor !== '' && this.secondaryColor !== '' && this.textColor !== '' && this.linkColor !== '') {
        this.removeStyles();
        this.addStyles();
      } else {
        alert('Please enter a value.');
      }
    },
    getColors: function getColors() {
      return {
        baseColor: this.baseColor,
        accentColor: this.accentColor,
        secondaryColor: this.secondaryColor,
        textColor: this.textColor,
        linkColor: this.linkColor
      };
    },
    addStyles: function addStyles() {
      var $style = document.createElement('style');
      var rules = document.createTextNode(this.styleTemplate(this.getColors()));

      $style.id = 'custom-styles';

      if ($style.styleSheet) {
        $style.styleSheet.cssText = rules.nodeValue;
      } else {
        $style.appendChild(rules);
      }
      document.getElementsByTagName('head')[0].appendChild($style);
    },
    removeStyles: function removeStyles() {
      var $style = document.getElementById('custom-styles');
      if ($style !== null) {
        $style.parentNode.removeChild($style);
      }
    },
    convertRGBa: function convertRGBa(hex, alpha) {
      return 'rgba(' + __WEBPACK_IMPORTED_MODULE_0_hex_rgb___default()(hex)[0] + ', ' + __WEBPACK_IMPORTED_MODULE_0_hex_rgb___default()(hex)[1] + ', ' + __WEBPACK_IMPORTED_MODULE_0_hex_rgb___default()(hex)[2] + ', ' + alpha + ')';
    },
    createFile: function createFile() {
      if (this.baseColor !== '' && this.accentColor !== '' && this.secondaryColor !== '' && this.textColor !== '' && this.linkColor !== '') {
        var blob = new Blob([this.styleTemplate(this.getColors())], { type: 'text/plain;charset=utf-8' });
        __WEBPACK_IMPORTED_MODULE_1_file_saver___default.a.saveAs(blob, 'uny-custom.css');
      } else {
        alert('Please enter a value.');
      }
    },
    styleTemplate: function styleTemplate(colors) {
      return '/*! UNY CSS Framework @1x | unycss.com | Copyright 2017 kokushin | MIT license */\n\n::-webkit-input-placeholder {\n  color: ' + this.convertRGBa(colors.textColor, 0.3) + ';\n}\n\n::-moz-placeholder {\n  color: ' + this.convertRGBa(colors.textColor, 0.3) + ';\n}\n\n:-ms-input-placeholder {\n  color: ' + this.convertRGBa(colors.textColor, 0.3) + ';\n}\n\n:-moz-placeholder {\n  color: ' + this.convertRGBa(colors.textColor, 0.3) + ';\n}\n\na { color: ' + colors.linkColor + '; }\n\nhr { background-color: ' + colors.secondaryColor + '; }\n\nbody {\n  background-color: ' + colors.baseColor + ';\n  color: ' + colors.textColor + ';\n}\n\npre:before {\n  background-color: ' + colors.secondaryColor + ';\n  color: ' + colors.textColor + ';\n}\n\npre code {\n  border-color: ' + colors.secondaryColor + ';\n  background-color: ' + this.convertRGBa(colors.textColor, 0.1) + ';\n  color: ' + colors.textColor + ';\n}\n\ncode {\n  background-color: ' + this.convertRGBa(colors.textColor, 0.1) + ';\n}\n\nfigure figcaption {\n  color: ' + colors.textColor + ';\n}\n\n.video .video-caption {\n  color: ' + colors.textColor + ';\n}\n\n.logo {\n  color: ' + colors.textColor + ';\n}\n\n.logo a {\n  outline-color: ' + colors.linkColor + ';\n  color: ' + colors.textColor + ';\n}\n\n.button {\n  background-color: ' + colors.accentColor + ';\n  border-color: ' + colors.accentColor + ';\n}\n\n.button.is-burger span, .button.is-close span {\n  background-color: ' + colors.textColor + ';\n}\n\n.button.is-list {\n  background-color: transparent;\n  color: ' + colors.textColor + ';\n}\n\n.button.is-list + .button.is-list {\n  border-color: ' + colors.secondaryColor + ';\n}\n\n.button.is-icon {\n  color: ' + colors.textColor + ';\n}\n\ntable th {\n  border-color: ' + colors.secondaryColor + ';\n}\n\ntable tr:nth-child(even) td {\n  background-color: ' + this.convertRGBa(colors.textColor, 0.1) + ';\n}\n\n.input:not(label) {\n  background-color: ' + this.convertRGBa(colors.textColor, 0.1) + ';\n  border-color: transparent;\n  color: ' + colors.textColor + ';\n}\n\n.input:not(label):hover {\n  border-color: ' + this.convertRGBa(colors.textColor, 0.1) + ';\n}\n\n.input:not(label):focus {\n  border-color: ' + colors.linkColor + ';\n  -webkit-box-shadow: 0 0 4px ' + colors.linkColor + ';\n          box-shadow: 0 0 4px ' + colors.linkColor + ';\n}\n\n.input.is-disabled, .input[disabled] {\n  color: ' + this.convertRGBa(colors.textColor, 0.3) + ';\n  background-color: ' + this.convertRGBa(colors.textColor, 0.1) + ';\n  border-color: ' + colors.secondaryColor + ';\n}\n\n.input.is-file {\n  background-color: ' + colors.accentColor + ';\n  border-color: ' + colors.accentColor + ';\n  color: ' + colors.textColor + ';\n}\n\n.input.is-select {\n  background-color: ' + colors.accentColor + ';\n}\n\n.input.is-select:after {\n  color: ' + colors.textColor + ';\n}\n\n.input.is-select > select {\n  color: ' + colors.textColor + ';\n  border-color: ' + colors.accentColor + ';\n}\n\n.input.is-select > select:focus {\n  border-color: ' + colors.linkColor + ';\n  -webkit-box-shadow: 0 0 4px ' + colors.linkColor + ';\n          box-shadow: 0 0 4px ' + colors.linkColor + ';\n}\n\n.input.is-checkbox:hover > span:before {\n  border-color: ' + colors.accentColor + ';\n}\n\n.input.is-checkbox > input[type=checkbox]:checked + span:before {\n  background-color: ' + colors.accentColor + ';\n  border-color: ' + colors.accentColor + ';\n}\n\n.input.is-radio:hover > span:before {\n  border-color: ' + colors.accentColor + ';\n}\n\n.input.is-radio > input[type=radio]:checked + span:before {\n  background-color: ' + colors.accentColor + ';\n  border-color: ' + colors.accentColor + ';\n}\n\n.input-filename {\n  color: ' + this.convertRGBa(colors.textColor, 0.5) + ';\n}\n\n.is-brand {\n  background-color: ' + colors.accentColor + ';\n}\n\n.is-gradation {\n  background: -webkit-gradient(linear, right top, left top, from(' + colors.baseColor + '), to(' + colors.accentColor + '));\n  background: linear-gradient(270deg, ' + colors.baseColor + ', ' + colors.accentColor + ');\n  background-size: 200% 200%;\n  -webkit-animation: isGradation 5s ease infinite;\n          animation: isGradation 5s ease infinite;\n  color: ' + colors.textColor + ';\n}\n\n.is-gradation a {\n  color: ' + colors.textColor + ';\n}\n\n@-webkit-keyframes isGradation {\n  0%{\n    background-position: 0% 50%;\n  }\n  50%{\n    background-position: 100% 50%;\n  }\n  100%{\n    background-position: 0% 50%;\n  }\n}\n\n@keyframes isGradation {\n  0%{\n    background-position: 0% 50%;\n  }\n  50%{\n    background-position: 100% 50%;\n  }\n  100%{\n    background-position: 0% 50%;\n  }\n}\n\nblockquote {\n  border-color: ' + colors.secondaryColor + ';\n}\n\n.content {\n  background-color: $base-color;\n}\n\n.section + .section {\n  border-top-color: ' + colors.secondaryColor + ';\n}\n\n.section.is-gray {\n    background-color: ' + colors.secondaryColor + ';\n}\n\n.box.is-border {\n  border-color: ' + colors.secondaryColor + ';\n}\n\n.header,\n.footer {\n  background-color: ' + colors.secondaryColor + ';\n}\n\n.header.is-sticky {\n  background-color: ' + colors.secondaryColor + ';\n}\n\n.header-menu a:not(.button) {\n  color: ' + colors.textColor + ';\n}\n\n.card {\n  background-color: ' + colors.baseColor + ';\n  border-color: ' + colors.accentColor + ';\n}\n\n.card.is-clickable > * {\n  color: ' + colors.textColor + ';\n}\n\n.card.is-skeleton {\n  border-color: ' + colors.secondaryColor + ';\n}\n\n.card.is-skeleton > * {\n  color: ' + this.convertRGBa(colors.textColor, 0.3) + ';\n}\n\n.card.is-dialog .card-header,\n  .card.is-dialog .card-content,\n  .card.is-dialog .card-footer {\n    border-color: ' + colors.secondaryColor + ';\n}\n\n.offcanvas .offcanvas-content {\n  background-color: ' + colors.baseColor + ';\n}\n\n.offcanvas .offcanvas-menu a:not(.button) {\n  color: ' + colors.textColor + ';\n}\n\n.sidebar:first-child {\n  border-color: ' + colors.secondaryColor + ';\n}\n\n.sidebar:not(:first-child) {\n  border-color: ' + colors.secondaryColor + ';\n}\n\n.tab .tab-list {\n  border-color: ' + colors.secondaryColor + ';\n}\n\n.tab .tab-list a {\n  background-color: ' + colors.baseColor + ';\n  border-color: ' + colors.secondaryColor + ';\n  color: ' + colors.textColor + ';\n}\n\n.tab .tab-list a.is-current {\n  color: ' + colors.linkColor + ';\n}\n\n.tab .tab-content {\n  border-color: ' + colors.secondaryColor + ';\n}\n\n.navbar a:not(.button) {\n  color: ' + colors.textColor + ';\n}\n\n.navbar a.is-current {\n  background-color: ' + colors.accentColor + ';\n}\n\n.tree ul ul,\n.tree ul ol,\n.tree ol ul,\n.tree ol ol {\n  border-color: ' + colors.secondaryColor + ';\n}\n\n.tree ul > li a, .tree ol > li a {\n  color: ' + colors.textColor + ';\n}\n\n.tree ul > li.is-current > a, .tree ol > li.is-current > a {\n  background-color: ' + colors.accentColor + ';\n}\n\n.hero {\n  background-color: ' + colors.secondaryColor + ';\n}\n\n.field .button {\n  color: ' + colors.textColor + ';\n  background-color: ' + colors.accentColor + ';\n  border-color: ' + colors.accentColor + ';\n}\n\n.snackbar {\n  background-color: ' + colors.accentColor + ';\n}\n\n.pulldown .pulldown-content {\n  background-color: ' + colors.baseColor + ';\n  border: 1px solid ' + colors.secondaryColor + ';\n}\n\n.tabbar {\n  background-color: ' + colors.accentColor + ';\n}\n\n.tabbar a:not(.button) {\n  color: ' + colors.textColor + ';\n}\n\n.tabbar .button.is-icon {\n  color: ' + colors.textColor + ';\n}\n\n.pager {\n  border-color: ' + colors.secondaryColor + ';\n}\n\n.pager > li > a {\n  border-color: ' + colors.secondaryColor + ';\n  color: ' + colors.textColor + ';\n}\n\n.pager > li > span.is-current {\n  border-color: ' + colors.accentColor + ';\n  background-color: ' + colors.accentColor + ';\n}\n\n.modal .modal-content > .inner {\n  background-color: ' + colors.baseColor + ';\n}\n\n.modal .modal-content > .card.is-dialog .button {\n  color: ' + colors.linkColor + ';\n}\n\n.modal .modal-content > .card.is-dialog .button + .button {\n  border-color: ' + colors.secondaryColor + ';\n}\n\n@media (min-width: 769px) {\n  .sidebar:first-child {\n    border-color: ' + colors.secondaryColor + ';\n  }\n\n  .sidebar:not(:first-child) {\n    border-color: ' + colors.secondaryColor + ';\n  }\n}';
    }
  }
});

/***/ }),

/***/ "nBUJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Workspace__ = __webpack_require__("/dr+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Preview__ = __webpack_require__("KvDf");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Workspace: __WEBPACK_IMPORTED_MODULE_0__components_Workspace__["a" /* default */],
    Preview: __WEBPACK_IMPORTED_MODULE_1__components_Preview__["a" /* default */]
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.5f98867df6d6ecddb225.js